import React, { useState, useEffect } from 'react';
import RichTable from '../components/richTable/RichTable.jsx'
import tableHelpers from '../helpers/TableHelpers.js'
import { Link } from 'react-router-dom'
import LinearProgress from '@mui/material/LinearProgress';
import OHLCBarChart from '../components/OHLCBarChart.js'
import AutomateTrade from '../trades/AutomateTrade.js'
import StockQuickLookDrawer from '../stock/StockQuickLookDrawer.js'
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';

function Indicators(props) {

    const [data, setData] = useState(null)
    const [updates, setUpdates] = useState(0)
    const [isPlacingOrder, setIsPlacingOrder] = useState(false);
    const [trade, setTrade] = useState(null);
    const [showMoreRows, setShowMoreRows] = useState(false);

    useEffect(() => {
        (async function () {

            let symbols = "";

            if (props.shouldLoadSymbols) {
                const syms = await (await fetch(`/api/strategySymbols`)).json();
                if (syms && syms.length) {
                    syms.forEach(a => {
                        symbols += a + ",";
                    })
                }
            } else {
                if (props.symbols && Array.isArray(props.symbols) && props.symbols.length) {
                    props.symbols.forEach(a => {
                        symbols += a + ",";
                    })
                }
            }

            if (symbols && symbols !== "") {
                const query = `/api/stockIndicators?symbols=` + symbols;
                let d = await (await fetch(query)).json();
                console.log("data", d);

                // Fetch positions from the API
                const positionsQuery = `/api/positions?planId=${props.planId}`;
                const positions = await (await fetch(positionsQuery)).json();
                console.log("positions", positions);

                // Add `isHeld` property to data where symbol matches netSymbol in positions
                const updatedData = d.map(item => {
                    const isHeld = positions.some(position => position.netSymbol === item.symbol);
                    return { ...item, isHeld };
                });

                setData(updatedData);
            }

        })();
    }, [props.symbols, props.shouldLoadSymbols, updates, props.planId]);

    function getData() {
        return data;
    }

    function symbolFormatter(cell, row) {
        return <div class='sameline'>
            {row.isHeld ? "🚨 " : null}<StockQuickLookDrawer symbol={cell} planId={props.planId} mobileView={props.mobileView} userId={props.userId} accountId={props.accountId} />
            {props.brokerage ? <Link onClick={() => openPlaceTradeModal(cell, 1)}> ⤴️</Link> : null}
        </div>
    }

    function sma20Formatter(cell, row) {
        return tableHelpers.boolFormatter(cell, row) +
            (row.upward20Sma ? " ⬆️" : " ⬇️")
    }
    function sma50Formatter(cell, row) {
        return tableHelpers.boolFormatter(cell, row) +
            (row.upward50Sma ? " ⬆️" : " ⬇️")
    }
    function sma5Formatter(cell, row) {
        return tableHelpers.boolFormatter(cell, row) +
            (row.upward5Sma ? " ⬆️" : " ⬇️")
    }
    function smaCompositeFormatter(cell, row) {
        return tableHelpers.boolFormatter(row.above5sma, row) + " " +
            tableHelpers.boolFormatter(row.above20sma, row) + " " +
            tableHelpers.boolFormatter(row.above50sma, row) + " " +
            tableHelpers.boolFormatter(row.above200sma, row)
    }
    function sma200Formatter(cell, row) {
        return tableHelpers.boolFormatter(cell, row) +
            (row.upward200Sma ? " ⬆️" : " ⬇️")
    }

    function todayChangeFormatter(cell, row) {
        let highChange = (row.today.high - row.today.previous_close) / row.today.previous_close * 100;
        let lowChange = (row.today.low - row.today.previous_close) / row.today.previous_close * 100;
        let openChange = (row.today.open - row.today.previous_close) / row.today.previous_close * 100;
        let change = cell;

        return (
            <OHLCBarChart width="80px" hideLabels={true} high={highChange} low={lowChange} open={openChange} close={change} />
        );
    }

    function openPlaceTradeModal(symbol, quantity) {
        setTrade({
            symbol: symbol,
            shares: Number(quantity)
        })
        setIsPlacingOrder(true);
    }

    function expand() {
        setShowMoreRows(true);
    }

    function stochDFormatter(cell, row) {
        return tableHelpers.intFormatter(cell, row) + (row.upwardStochD ? " ⬆️" : " ⬇️")
    }

    return (
        <>
            <div>
                {data ?
                    <>
                        {props.mobileView ?
                            <>
                                <RichTable data={getData()} mappers={[
                                    { title: `Symbol`, field: 'symbol', formatter: symbolFormatter, hidden: props.hideSymbol ? true : false },
                                    { title: `Drawdown`, field: 'drawdown', formatter: tableHelpers.percentFormatter },
                                    { title: `20 BB`, field: 'stdDevFrom20Sma', formatter: tableHelpers.signedDecimalFormatter },
                                    { title: `Volatility`, field: 'relativeVolatility', formatter: tableHelpers.percentChangeFormatter },
                                    { title: `5,20,50,200`, field: 'above5sma', formatter: smaCompositeFormatter },
                                ]} className="table-striped table-hover table-condensed" />
                                {showMoreRows ?
                                    <RichTable data={getData()} mappers={[
                                        { title: `RSI`, field: 'rsi14', formatter: tableHelpers.intFormatter },
                                        { title: `RSI3`, field: 'rsi3', formatter: tableHelpers.intFormatter },
                                        { title: `StochD`, field: 'stochD', formatter: stochDFormatter },
                                        { title: `IBS`, field: 'ibs', formatter: tableHelpers.intFormatter },
                                        { title: `50 BB`, field: 'distanceFrom50Sma', formatter: tableHelpers.signedDecimalFormatter },

                                    ]} className="table-striped table-hover table-condensed" />
                                    :
                                    <>
                                        {!props.hideMobileMoreLink ?
                                            <>
                                                <Link onClick={() => expand()}>More</Link> &nbsp;<ExpandCircleDownIcon onClick={() => expand()} />
                                            </>
                                            : null}
                                    </>
                                }
                            </>
                            :
                            <RichTable data={getData()} mappers={[
                                { title: `Symbol`, field: 'symbol', sorters: true, formatter: symbolFormatter, hidden: props.hideSymbol ? true : false },
                                { title: `Today`, field: 'todaysChangePercent', sorters: true, formatter: todayChangeFormatter },
                                { title: `Drawdown`, field: 'drawdown', sorters: true, formatter: tableHelpers.percentFormatter },
                                { title: `20 BB`, field: 'stdDevFrom20Sma', formatter: tableHelpers.signedDecimalFormatter, sorters: true },
                                { title: `50 BB`, field: 'distanceFrom50Sma', formatter: tableHelpers.signedDecimalFormatter, sorters: true },
                                { title: `Volatility`, field: 'relativeVolatility', formatter: tableHelpers.percentChangeFormatter },
                                { title: `5 SMA`, field: 'above5sma', formatter: sma5Formatter },
                                { title: `20 SMA`, field: 'above20sma', formatter: sma20Formatter },
                                { title: `50 SMA`, field: 'above50sma', formatter: sma50Formatter },
                                { title: `200 SMA`, field: 'above200sma', formatter: sma200Formatter },
                                { title: `RSI3`, field: 'rsi3', sorters: true, formatter: tableHelpers.intFormatter },
                                { title: `RSI14`, field: 'rsi14', sorters: true, formatter: tableHelpers.intFormatter },
                                { title: `StochD`, field: 'stochD', formatter: stochDFormatter },
                                { title: `IBS`, field: 'ibs', sorters: true, formatter: tableHelpers.intFormatter },
                            ]} className="table-striped table-hover table-condensed" />
                        }
                        {props.hideReload ? null :
                            <Link onClick={() => setUpdates(updates + 1)}>🔄 Reload</Link>
                        }
                    </>
                    :
                    <LinearProgress />

                }
            </div >
            <AutomateTrade brokerage={props.brokerage} trade={trade} userId={props.userId} accountId={props.accountId} isOpen={isPlacingOrder} onClose={() => setIsPlacingOrder(false)} mobileView={props.mobileView} />
        </>
    );
}

export default Indicators;